import React from 'react';
import Iframe from 'react-iframe';

import * as Constants from "./Constants.js";

class ViewPanel extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      clientWidth: -1,
      clientHeight: -1,
      clientMargin: 12,
      clientPadding: 12,
      navbarHeight: 52
    }
    this.updateDimensions = this.updateDimensions.bind(this);
    this.handleAnchorClick = this.handleAnchorClick.bind(this);
  }
  
  handleAnchorClick(o) {
    //window.location.href = o.href;
    window.open(o.href, '_top');
  }
  
  updateDimensions() {
    if (this.refs && this.refs.viewerContainer) {
      let { clientHeight, clientWidth } = this.refs.viewerContainer;
      this.setState({
        clientWidth: clientWidth - (2 * this.state.clientMargin) - (2 * this.state.clientPadding),
        clientHeight: clientHeight - (2 * this.state.clientMargin) - (2 * this.state.clientPadding) - this.state.navbarHeight
      });
    }
  }
  
  render() {
    return (
      <div className={(this.props.dataState === "valid") ? "viewer-container" : "viewer-container-no-margin"} ref="viewerContainer">
        {(this.props.dataState === "valid") ? <Iframe allowFullScreen url={this.props.dataURL} position="relative" display="initial" width="100%" height="100%" /> : <div>Analysis results were not found for this id, or the analysis has not run to completion. Please check your email for updated status, or use the <span onClick={() => this.handleAnchorClick({href:Constants.rootURL})}><span className="anchor-text">job designer</span></span> to submit a new analysis.</div>}
      </div>
    );
  }
}

export default ViewPanel;